import {RREmployeePPH, RREmployeePPHs, RREmployeeRateActor} from "../../types/RREmployeeType";
import {firebaseDateToDate} from "../../tools";

export type EmployeeRateAuditUser = {
    id?: string;
    name?: string;
    email?: string | null;
}

export function getEmployeeRateActor(user?: EmployeeRateAuditUser): RREmployeeRateActor {
    return {
        id: user?.id || null,
        name: user?.name?.trim() || user?.email?.trim() || "Неизвестен потребител",
    };
}

export function createEmployeeRate(
    existingRateCount: number,
    actor: RREmployeeRateActor,
    createdAt: Date = new Date(),
): RREmployeePPH {
    const effectiveFrom = new Date(createdAt);
    // Бизнес правило: първата ставка е начална и не минава през отделно одобрение.
    const isInitialRate = existingRateCount === 0;

    return {
        fromDate: effectiveFrom,
        effectiveFrom,
        isApproved: isInitialRate,
        pph: 0,
        supervisor_pph: 0,
        createdAt: new Date(createdAt),
        createdBy: actor,
        ...(isInitialRate ? {
            approvedAt: new Date(createdAt),
            approvedBy: actor,
        } : {}),
    };
}

export function prepareEmployeeRateEdit(
    previousRate: RREmployeePPH,
    editedRate: RREmployeePPH,
    index: number,
    actor: RREmployeeRateActor,
    editedAt: Date = new Date(),
): RREmployeePPH {
    if (index === 0) {
        return {...editedRate, isApproved: true};
    }

    const rateWasApproved = previousRate.isApproved;
    const rateWithoutApproval = {...editedRate};
    delete rateWithoutApproval.approvedAt;
    delete rateWithoutApproval.approvedBy;

    return {
        ...rateWithoutApproval,
        isApproved: false,
        createdAt: rateWasApproved || !editedRate.createdAt ? new Date(editedAt) : editedRate.createdAt,
        createdBy: rateWasApproved || !editedRate.createdBy ? actor : editedRate.createdBy,
    };
}

export function approveEmployeeRates(
    rates: RREmployeePPHs,
    actor: RREmployeeRateActor,
    approvedAt: Date = new Date(),
): RREmployeePPHs {
    // Не дописваме фиктивна история към вече одобрени стари ставки.
    return rates.map(rate => rate.isApproved ? rate : {
        ...rate,
        isApproved: true,
        approvedAt: new Date(approvedAt),
        approvedBy: actor,
    });
}

export function getEmployeeRateEffectiveFrom(rate: RREmployeePPH): Date {
    return rate.effectiveFrom || rate.fromDate;
}

export function convertEmployeeRateDates(rate: RREmployeePPH): RREmployeePPH {
    return {
        ...rate,
        fromDate: firebaseDateToDate(rate.fromDate),
        ...(rate.effectiveFrom ? {effectiveFrom: firebaseDateToDate(rate.effectiveFrom)} : {}),
        ...(rate.createdAt ? {createdAt: firebaseDateToDate(rate.createdAt)} : {}),
        ...(rate.approvedAt ? {approvedAt: firebaseDateToDate(rate.approvedAt)} : {}),
    };
}
